<template>
  <div class="form-add">
        <h2>Agregar</h2>
        <div class="form-add__input-text">
            <label for="descripcion-input">Descripcion: </label>
            <input class="input-text" type="text" id="descripcion-input" v-model="newProduct.descripcion">

            <label for="precio-input">Precio: </label>
            <input class="input-text" type="number" id="precio-input" v-model="newProduct.precio">
        </div>

        <input
        type="file"
        name="product"
        id="productImageInput"
        accept="image/png, image/jpeg"
        @change="onFileSelected($event)"
        />
        
        <img class="form-add__image" :src="newProduct.imageUrl || require('../assets/wardrobe.png')" alt="">
        <div class="add-tags">
            <h3 class="add-tags__title">Tags</h3>
            <input @keyup.enter="addTag(newTag)" v-model="newTag" class="add-tags__input-tag input-text" type="text" placeholder="+ Add a tag and press Enter">
            <ul class="add-tags__list">
                <li v-for="(tag,index) in newProduct.tags" :key="tag+index">{{tag}} <span class="add-tags__remove" @click="removeTag(tag)">x</span></li>
            </ul>
        </div>
        <button class="button" @click="onUpload" type="button">Guardar</button>
  </div>
</template>

<script>
import { storageRef, storage } from "../main";
import { getAuth } from "firebase/auth"
import gql from "graphql-tag";
export default {
    name:"AddProduct",
    data(){
        return{
            file: null,
            newTag: null,
            newProduct: {
                descripcion: "",
                imageUrl: null,
                precio: null,
                tags: [],
            }
        }
    },
    methods:{
        onFileSelected(event) {
            if(event.target.files[0] != null){
                this.file = event.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onload = (e) => {
                    this.newProduct.imageUrl = e.target.result;
                };
            };
        },
        removeTag(tag){
            let index = this.newProduct.tags.indexOf(tag);
            if(index !== -1){
                this.newProduct.tags.splice(index,1);
            }
        },
        addTag(tag){
            if(tag !== null && tag !== "" && !this.newProduct.tags.includes(tag)){
                this.newProduct.tags.push(tag);
                this.newTag = "";
            }
        },
        generateName() {
            return "col_" + Math.random().toString(36).substr(2, 9);
        },
        async generateNameWithExtension(name) {
            let extension = name.split(".")[1];
            let exist = true;
            let fileName = null;
            while (exist) {
                try {
                let name = this.generateName();
                fileName = name + "." + extension;
                await storageRef.child("productos").child(fileName).getDownloadURL();
                } catch (error) {
                exist = false;
                }
            }
            return fileName;
        },

        async onUpload() {
            const auth = getAuth();
            if(this.file != null){
                let fileNameGenerated = await this.generateNameWithExtension(
                    this.file.name
                );
                try {
                    await storageRef
                    .child("productos")
                    .child(fileNameGenerated)
                    .put(this.file);
                    let urlDescarga = await storageRef
                    .child("productos")
                    .child(fileNameGenerated)
                    .getDownloadURL();
                    this.newProduct.imageUrl = urlDescarga;
    
                    this.addProduct();
                    
                } catch (error) {
                    console.log(error);
                }
            }
        },

        addProduct(){
            this.$apollo.mutate({
                mutation: gql`
                mutation CreateProduct($productInput: ProductInput) {
                createProduct(productInput: $productInput) {
                    id
                    descripcion
                    imageUrl
                    precio
                    tags
                    }
                }
                `,
                variables:{
                    productInput: this.newProduct
                }
            })
            .then((res)=>{
                this.newProduct.descripcion = "";
                this.newProduct.imageUrl= null;
                this.newProduct.precio= null;
                this.newProduct.tags = [];
                this.file = null;
                document.getElementById("productImageInput").value = "";
                
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Articulo guardado',
                    showConfirmButton: false,
                    timer: 1500
                    })
            })
            .catch((err)=>{
                console.error(err);
            })
        }
    }
}
</script>

<style lang="scss">
.form-add{
    width: 80%;
    margin: auto;
    margin-bottom: 1em;

    &__image{
        height: 15em;
        width: 15em;
        margin: .5em auto;
    }

    &__input-text{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-items: start;
        align-items: center;
        row-gap: .5em;
        padding: .3em 0;

        input{
            font-size: 1em;
        }
    }

    input[type="file"]{
        width: 100%;
    }
}
.add-tags{

    &__title{
        text-align: left;
    }

    &__list{
        list-style: none;
        width: 100%;
        min-height: 2em;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #ddd;
        padding: .5em 0 0 .5em;
        margin: .5em auto;
        color: black;

        li{
            background-color: #5DF3B3;
            border: 1px solid #5DF3B3;
            width: fit-content;
            padding: .1em .5em;
            border-radius: .5em;
            margin-right: .5em;
            margin-bottom: .5em;
            color: #fff;
            font-weight: bold;
            span{
                font-size: 1.1em;
                margin-left: .5em;
                color: #000;
            }
        }
    }

    &__input-tag{
        font-size: 1.2em;
        margin-bottom: .5em;
    }
}
@media (min-width: 850px){
    .form-add{
        width: 50%;
    }
}
</style>